import store from '@/store'
export default [
	{
		path: '/quotations',
		name: 'quotation',
		meta: { requiresAuth: true },
		component: () => import('@/pages/quotation/index.vue')
	},
	{
		path: '/quotations/create',
		name: 'quotation-create',
		meta: { requiresAuth: true },
		component: () => import('@/pages/quotation/create.vue')
	},
	{
		path: '/quotations/:id',
		name: 'quotation-show',
		meta: { requiresAuth: true },
		component: () => import('@/pages/quotation/show.vue'),
		beforeEnter: async (to, from, next) => {
			await store.dispatch('quotation/find', to.params.id)
			next()
		}
	}
]
